import {
  getProductConfig,
  registerProduct,
} from "../../registry/product-registry";
import { shopperAgentProductConfig } from "./tasks";

let registered = false;

export function registerShopperAgentProduct(): void {
  if (registered || getProductConfig(shopperAgentProductConfig.product)) {
    registered = true;
    return;
  }
  registerProduct(shopperAgentProductConfig);
  registered = true;
}
